import * as actionType from "../types/ActionTypes";
import axios from "../../shared/axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../shared/baseURL";

export const coursesSetData = (courses) => {
  return {
    type: actionType.COURSES_SET_DATA,
    courses: courses,
  };
};

export const coursesFailData = (error) => {
  return {
    type: actionType.COURSES_FAIL_DATA,
    error: error,
  };
};

export const coursesLoading = () => {
  return {
    type: actionType.COURSES_LOADING,
  };
};

export const coursesGetData = () => {
  return (dispatch) => {
    dispatch(coursesLoading());
    axios
      .get(baseUrl + "/courses", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(coursesSetData(res.data));
      })
      .catch((error) => dispatch(coursesFailData(error)));
  };
};


export const deleteCoursesFail = (error) => {
  return {
    type: actionType.DELETE_COURSES_FAIL,
    error: error,
  };
};

export const deleteCourses = (id, data) => {
  return (dispatch) => {
    if (id) {
      axios
        .delete(baseUrl + `/courses/${data.id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data?.token,
          },
        })
        .then(() => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              dispatch(coursesGetData(data));
            }
          );
        })
        .catch((error) => dispatch(deleteCoursesFail()));
    }
  };
};

export const postCoursesDataStart = () => {
  return {
    type: actionType.POST_COURSES_DATA_START,
  };
};

export const postCoursesDataFail = (error) => {
  return {
    type: actionType.POST_COURSES_DATA_FAIL,
    error: error,
  };
};

export const postCoursesDataSuccess = (success) => {
  return {
    type: actionType.POST_COURSES_DATA_SUCCESS,
    success: success,
  };
};

export const coursesPostLoading = () => {
  return {
    type: actionType.COURSES_POST_LOADING,
  };
};

export const postCoursesData = (data, courses, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(postCoursesDataStart());
    dispatch(coursesPostLoading());
    axios
      .post(baseUrl + "/courses", courses, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(postCoursesDataSuccess(res.data));
        dispatch(coursesGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(postCoursesDataFail(error));
      });
  };
};

export const updateCoursesDataStart = () => {
  return {
    type: actionType.UPDATE_COURSES_DATA_START,
  };
};

export const coursesUpdateLoading = () => {
  return {
    type: actionType.COURSES_UPDATE_LOADING,
  };
};

export const updateCoursesDataFail = (error) => {
  return {
    type: actionType.UPDATE_COURSES_DATA_FAIL,
    error: error,
  };
};

export const updateCoursesDataSuccess = (success) => {
  return {
    type: actionType.UPDATE_COURSES_DATA_SUCCESS,
    success: success,
  };
};

export const updateCoursesData = (data, courses, toggle, setSubmitting) => {
  return (dispatch) => {
    dispatch(updateCoursesDataStart());
    dispatch(coursesUpdateLoading());

    axios
      .put(baseUrl + `/courses/${data.id}`, courses, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + data.token,
        },
      })
      .then((res) => {
        dispatch(updateCoursesDataSuccess(res.data));
        dispatch(coursesGetData(data));
        Swal.fire({
          position: "success",
          icon: "success",
          title: "Successfully Updated !",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          if (toggle) {
            toggle();
          }
          if (setSubmitting) {
            setSubmitting(false);
          }
        });
      })
      .catch((error) => {
        if (setSubmitting) {
          setSubmitting(false);
        }
        dispatch(updateCoursesDataFail(error));
      });
  };
};
